import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface GenerationCostEvent {
  label: string;
  inputTokens: number;
  outputTokens: number;
  creditCost: number;
  balanceCredits?: number | null;
}

@Injectable({ providedIn: 'root' })
export class GenerationToastService {
  private readonly eventSubject = new Subject<GenerationCostEvent>();
  readonly event$ = this.eventSubject.asObservable();

  emit(event: GenerationCostEvent): void {
    this.eventSubject.next(event);
  }
}
